import { FormLabel as CommonFormLabel } from '@monorepo/common';

type Props = {
  children: React.ReactNode;
};

function FormLabel({ children }: Props) {
  return <CommonFormLabel showRequiredMark={false}>{children}</CommonFormLabel>;
}

export default FormLabel;
